var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('b-notification',{attrs:{"type":_vm.type,"closable":false},domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }